import { useContext } from 'react';
import Modal from 'react-modal';

import { Close } from 'components/icons';
import { LocaleContext } from 'components/rebrand/Layout';

import { ITrackEventProps } from 'typescriptDefs';

import { Button } from './Button';
import { GetApp } from './GetApp';
import { H3 } from './Typography';

type Props = {
  closeModal: () => void;
  intent: string;
  isOpen: boolean;
  qrCodeLink: string;
  smsLink: string;
  trackEventProps: ITrackEventProps;
};

export const OpenAppModal = ({ closeModal, intent, isOpen, qrCodeLink, smsLink, trackEventProps }: Props) => {
  const locale = useContext(LocaleContext);

  isOpen && Modal.setAppElement('#open-app-button');

  return (
    <Modal
      isOpen={isOpen}
      style={{
        overlay: {
          zIndex: 10,
          backgroundColor: 'rgba(55, 62, 77, 0.5)',
        },
        content: {
          width: '75%',
          maxWidth: '460px',
          padding: '32px',
          paddingTop: '24px',
          marginLeft: 'auto',
          marginRight: 'auto',
          borderRadius: '16px',
          height: 'fit-content',
          marginTop: 'auto',
          marginBottom: 'auto',
        },
      }}
    >
      <div data-theme="light" className="flex flex-col text-center">
        <Button variant="ghost" className="mb-8 ml-auto h-fit w-fit p-4" onClick={closeModal}>
          <Close className="h-24 w-24 text-grey-400" />
          <span className="sr-only">Close modal</span>
        </Button>
        <H3 className="mb-8 text-grey-400">
          {{ en: 'Get the KOHO app', fr: "Télécharger l'application KOHO" }[locale]}
        </H3>
        <GetApp intent={intent} qrCodeLink={qrCodeLink} smsLink={smsLink} trackEventProps={trackEventProps} />
      </div>
    </Modal>
  );
};
